module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oAbrFr/tc-custom/9783987446016.jpg?1704424602237",
      "alt": "This image is the cover for the book The Cosmic Computer, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Cosmic Computer, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("An incredulous story that was possibly the inspiration for A Hitchhikers Guide to the Galaxy by Douglas Adams. Set in a post-war world, with moralising messages to emphasise the dangers of nuclear war, the book tells the story of a troupe of armed adventurers embarking on a entrepreneurial initiative. (Goodreads)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      H. Beam Piper\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Henry Beam Piper (March 23, 1904 – c.  November 6, 1964) was an American science fiction writer. He wrote many short stories and several novels. He is best known for his extensive Terro-Human Future History series of stories and a shorter series of \"Paratime\" alternate history tales. He wrote under the name H. Beam Piper. Another source gives his name as \"Horace Beam Piper\" and a different date of death. His gravestone says \"Henry Beam Piper\". Piper himself may have been the source of part of the confusion; he told people the H stood for Horace, encouraging the assumption that he used the initial because he disliked his name.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0